import React from 'react';
import Modal from '~/app/common/Modal';
import Button from '~/app/common/Button';
import useTranslation from '~/app/hooks/useTranslation';
import classes from './style.module.scss';

export type WorkTypeChangeDialogProps = {
    isOpen: boolean;
    onKeepExisting: () => void;
    onChangeAll: () => void;
    onCancel: () => void;
};

export type WorkTypeChangeDialogComponent = React.FC<WorkTypeChangeDialogProps>;

const WorkTypeChangeDialog: WorkTypeChangeDialogComponent = ({
    isOpen,
    onKeepExisting,
    onChangeAll,
    onCancel,
}) => {
    const { t } = useTranslation('workorder');

    return (
        <Modal className={classes.dialog} open={isOpen} onClose={onCancel} position="bottom">
            <div className={classes.header}>
                <p className={classes.title}>{t('detail.workTypeChange.title')}</p>
                <p className={classes.message}>{t('detail.workTypeChange.message')}</p>
            </div>
            <div className={classes.actions}>
                <Button className={classes.actionPrimary} onClick={onKeepExisting}>
                    {t('detail.workTypeChange.keepExisting')}
                </Button>
                <Button className={classes.actionPrimary} onClick={onChangeAll}>
                    {t('detail.workTypeChange.changeAll')}
                </Button>
                <Button className={classes.actionCancel} onClick={onCancel}>
                    {t('detail.workTypeChange.cancel')}
                </Button>
            </div>
        </Modal>
    );
};

export default WorkTypeChangeDialog;
